import axios from "axios";
import { ATP_API_URL } from "config/apiConfig";

export const sendEntityKYCFormDataAction = async (payload) => {
  try {
    const response = await axios.post(
      ATP_API_URL.KYC_FORM_FIELDS_DATA,
      payload,
    );

    if (response.status === 200 && response.data?.success === true) {
      console.log("Resposne kyc form : ", response);
      return {
        success: true,
        data: response,
      };
    } else {
      return {
        success: false,
        error: response.data?.message || "Failed to create entity",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};
